import React, { useState, useEffect } from 'react';
import { APP_URL } from '../lib/config';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`sticky top-0 z-50 transition-all duration-300 ${
      isScrolled 
        ? 'bg-white/80 backdrop-blur-md shadow-lg rounded-2xl mx-auto mt-4 max-w-4xl' 
        : 'bg-white shadow-sm'
    }`}>
      <div className={`mx-auto px-4 sm:px-6 lg:px-8 ${
        isScrolled ? 'max-w-6xl' : 'max-w-7xl'
      }`}>
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="/assets/images/convalytics-ai-horizontal.svg" 
              alt="Convalytics AI" 
              className="h-12 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <a href="#how-it-works" className="text-gray-600 hover:text-[#0E666F] transition-colors">
              How It Works
            </a>
            <a href="#why-choose" className="text-gray-600 hover:text-[#0E666F] transition-colors">
              Why Choose Us
            </a>
            <a href="#faq" className="text-gray-600 hover:text-[#0E666F] transition-colors">
              FAQ
            </a>
            <a href="#contact-form" className="text-gray-600 hover:text-[#0E666F] transition-colors">
              Contact
            </a>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center">
            <a 
              href={APP_URL} 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center space-x-2 bg-gradient-to-r from-[#0E666F] to-[#0A4A52] hover:from-[#0A4A52] hover:to-[#0E666F] text-white px-4 py-2 rounded-lg transition-all duration-300 shadow-sm"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
              <span>Get Started</span>
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-600 hover:text-primary-600"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
              <a href="#how-it-works" className="block px-3 py-2 text-gray-600 hover:text-[#0E666F]">
                How It Works
              </a>
              <a href="#why-choose" className="block px-3 py-2 text-gray-600 hover:text-[#0E666F]">
                Why Choose Us
              </a>
              <a href="#faq" className="block px-3 py-2 text-gray-600 hover:text-[#0E666F]">
                FAQ
              </a>
              <a href="#contact-form" className="block px-3 py-2 text-gray-600 hover:text-[#0E666F]">
                Contact
              </a>
              <div className="pt-4">
                <a 
                  href={APP_URL} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 bg-gradient-to-r from-[#0E666F] to-[#0A4A52] hover:from-[#0A4A52] hover:to-[#0E666F] text-white px-4 py-2 rounded-lg transition-all duration-300 shadow-sm w-full justify-center"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                  <span>Get Started</span>
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
